import AuthFlowFrame from "components/AuthFlowFrame";
import ProXtraPromotionalPanel from "components/ProXtraPromotionalPanel";
import StatusTitle from "./Step3-StatusTitle";

// Per Jobber's feedback, the "Try it out" button opens a new quote with the
// Pro Xtra product tour.
const JOBBER_QUOTES_URL =
    "https://secure.getjobber.com/quotes/new?product_tour_id=641255";

function Step3Connected() {
    return (
        <AuthFlowFrame
            pretitle="Connect your Pro Xtra account"
            title={
                <StatusTitle
                    text="Account Connected"
                    iconName="checkmarkCircle"
                    variant="success"
                />
            }
            description="Your Pro Xtra account has been connected. You can view your custom pricing when adding products from The Home Depot catalog in your quotes and jobs."
            sidePanel={<ProXtraPromotionalPanel />}
            primaryButton={{
                text: "Try it out",
                url: JOBBER_QUOTES_URL,
            }}
        />
    );
}

export default Step3Connected;
